import React, {useEffect} from "react";
import {Container} from "react-bootstrap";
import HeaderTFAF from "./HeaderTFAF";
import FooterTFAF from "./FooterTFAF";
import {useLocation} from "react-use";
import {detectSource} from "../utils/sourceDetection";

const SessionExpired = props => {
    const location = useLocation();
    const source = detectSource();
    const isAAPath = source === 'AA' || source === 'AA_MEMBER';
    const isVTNZPath = source === 'VTNZ';
  const baseUrl = window.location.origin;

  const handleNewQuoteClick = () => {
      window.location.href = '/mbi';
    };
  useEffect(() => {
    if (!window.location.hostname.includes('aa')) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'mbiAutosureEvent',
        category: 'Session Expired',
        virtualUrl: `${baseUrl}/mbi/session_expired`,
        pageTitle: 'Session Expired',
      });
    }
  }, []);
    return (
        <>
        <HeaderTFAF/>

            <Container >
                <Container >
                    <div style={{textAlign: "center"}}>
                    <br/>
                    <br/>
                    <div className="redMediumTextStyles">Session Expired</div>
                    <br/>
                    <p
                       className="regularTextStyles"> To take another look at getting peace of mind protection for your car.</p>
                        <span style={{display:'grid', justifyContent:'center'}}>
                            <br/>
                    <button
                        onClick={handleNewQuoteClick}
                        style={{
                        color: 'white',
                        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                        borderRadius: 6,
                        paddingLeft: 25,
                        paddingRight: 25,
                        paddingTop: 13,
                        paddingBottom: 13,
                        overflow: 'hidden',
                        border: '1px white solid',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width:"100%",
                        maxWidth:"200px",
                          background: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#1851a3',
                        cursor: 'pointer',
                    }}>Get another quote</button></span>
                        <br/><br/><br/><br/>
                    </div>

                </Container>


            </Container>


            <FooterTFAF/>
        </>
    );
}

export default SessionExpired;
